import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationService } from '@core/services/notification.service';
import { UserMaintenanceSecurityWrapperService } from '@core/services/service-wrappers/user-maintenance-security-wrapper.service';
import { asyncScheduler, Observable } from 'rxjs';
import { map, take, observeOn } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'app-assign-roles-dialog',
  templateUrl: './assign-roles-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./assign-roles-dialog.component.scss']
})
export class AssignRolesDialogComponent implements OnInit {
  formGroup = new UntypedFormGroup({
    roles: new UntypedFormControl()
  });
  saving = false;
  loading = false;
  assignRolesOptions$: Observable<any[]>;
  selectedRoleIds = [];
  userId = '';
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private userMaintenanceSecurityService: UserMaintenanceSecurityWrapperService,
    private notificationService: NotificationService,
    public dialogRef: MatDialogRef<AssignRolesDialogComponent>
  ) {
    this.userId = data?.data.id;
    this.selectedRoleIds = data?.data?.userRoles?.map((item) => item.id ?? item.roleId) ?? [];
  }

  ngOnInit(): void {
    this.assignRolesOptions$ = this.getRoleList();
  }

  getRoleList(): Observable<any[]> {
    this.loading = true;
    return this.userMaintenanceSecurityService
      .apiV1RolePost({
        pageSize: 100
      })
      .pipe(
        take(1),
        observeOn(asyncScheduler),
        map((response) => {
          this.loading = false;
          return response?.data ?? [];
        })
      );
  }

  updateSelectedRoles(roleIds: string[]): void {
    this.selectedRoleIds = roleIds ?? [];
  }

  save() {
    this.saving = true;
    const formData = {
      userId: this.userId,
      roleIds: this.selectedRoleIds
    };
    let saveObservable: Observable<any>;
    let notification;
    notification = 'Roles Assigned';
    saveObservable = this.userMaintenanceSecurityService.apiV1UserRolesPost(formData).pipe(map((x: any) => x));

    saveObservable
      .pipe(take(1), observeOn(asyncScheduler))
      .subscribe(
        (response) => {
          this.dialogRef.close(true);
          this.notificationService.success(notification);
        },
        (err) => {
          this.notificationService.error('Saving User');
          this.saving = false;
        }
      );
  }

  trackById(index: number, item: any) {
    return item.id;
  }
}


